'use client';

import { VpIcon, VpIconButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import Lightbox from 'react-image-lightbox';

export const Zoom = ({ mainSrc }: ZoomProps) => {
  const t = useTranslations('GLOBAL');
  const [lightboxOpened, setLightboxOpened] = useState(false);

  return (
    <>
      <span className="zoom-button">
        <VpIconButton
          data-testid="picture-zoom"
          size="small"
          title={t('PICTURE_ZOOM')}
          variant="secondary"
          onClick={() => setLightboxOpened(true)}
          onKeyDown={e => e.key === 'Enter' && setLightboxOpened(true)}
        >
          <VpIcon name="eye" />
        </VpIconButton>
      </span>
      {lightboxOpened && (
        <Lightbox
          mainSrc={mainSrc}
          onCloseRequest={() => setLightboxOpened(false)}
        />
      )}
    </>
  );
};

export interface ZoomProps {
  mainSrc: string;
}
